import { fg } from '@atlaskit/platform-feature-flags';

/**
 * Returns true for middle-clicks (button === 1) only.
 * Right-clicks are excluded to avoid double-counting with onContextMenu.
 * Gated behind `rovo_search_auxclick_hardening` for safe rollout.
 */
export const isAuxClick = (e: { button: number }): boolean => {
	if (fg('rovo_search_auxclick_hardening')) {
		return e.button === 1;
	}
	return true;
};
